module.exports = __webpack_public_path__ + "static/logo_poppins-46ab60fc7e2da313f729b86c41f49959.png";